"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatHorizontalFlex = formatHorizontalFlex;
exports.formatVerticalFlex = formatVerticalFlex;
/* Flexbox util functions */

/* align vertical values */
function formatVerticalFlex(vertical) {
  var verticalStyle;
  switch (vertical) {
    case 'top':
    case 'flex-start':
      verticalStyle = 'flex-start';
      break;
    case 'bottom':
    case 'flex-end':
      verticalStyle = 'flex-end';
      break;
    case 'middle':
    case 'center':
      verticalStyle = 'center';
      break;
    case 'full':
    case 'fill':
    case 'stretch':
      verticalStyle = 'stretch';
      break;
    case 'space-around':
      verticalStyle = 'space-around';
      break;
    case 'space-between':
      verticalStyle = 'space-between';
      break;
    default:
      verticalStyle = 'center';
  }
  return verticalStyle;
}

/* align hortizontal values */
function formatHorizontalFlex(horizontal) {
  var horizontalStyle;
  switch (horizontal) {
    case 'left':
    case 'flex-start':
      horizontalStyle = 'flex-start';
      break;
    case 'right':
    case 'flex-end':
      horizontalStyle = 'flex-end';
      break;
    case 'middle':
    case 'center':
      horizontalStyle = 'center';
      break;
    case 'space-around':
      horizontalStyle = 'space-around';
      break;
    case 'space-between':
      horizontalStyle = 'space-between';
      break;
    default:
      horizontalStyle = 'space-between';
  }
  return horizontalStyle;
}
//# sourceMappingURL=formatFlexAlign.js.map